const featureFlags = {
  // Cobler
  cobler: false,

  // Sidebar Version
  sidebar: false,
  toggleFeatureFlag: false,

  // Developer Tools
  developerTools: false,

  // Update version
  herbieDashboardVersion: '0.0.1',
  herbieDashboardVersionTestLocal: '0.0.1',
  forceUpdateVersionDashboard: false,

  // Monitoring
  activityCompletionStatus: false,
  devicesPollingIntervalWithSse: 300000,
  devicesSlideSseTimeInMs: 10100,
  idleTime: true,
  maxElementsForAlertReport: 25000,
  removedDevice: false,
  routeMapMatching: false,
  showFleetPolicyPage: false,
  unconstrainPaginetaAutocomplete: false,
  showDeviceObservation: false,
  deviceSynchronizingStatusThreshold: 45,
  navbarExportChecklist: false,
  trackingForceVisibilityGeofence: false,

  // Fleet Events
  enableFleetEvents: false,
  enableV2FleetEvents: false,
  libraryExtensionEventSource: false,

  internationalAddressAutocomplete: false,

  // Analytics
  fuelCardAlelo: false,
  fuelCardManual: false,
  fuelCardMaxifrota: false,
  fuelCardPrime: false,
  fuelCardSodexo: false,
  fuelCardTicketlog: false,
  fuelCardCtasmart: false,
  showIncidentsReport: false,
  coblinator: false,
  enableBrokenFuelCardIntegrationBanner: false,
  identifierAssociations: false,

  // Account Management
  driverIdentification: false,
  showCustomerSection: false,

  // Account Experience
  teamManagementTypeform: false,
  allowList: false,
  vehicleImmobilizer: false,
  cadastroDeIdentificadoresOrbital: false,

  // Livestream
  livestream: false,
  livestreamPage: false,
  livestreamMulti: false,

  // Videos
  disableWifiConfiguration: false,
  videoImpactEvent: false,
  mediaEventLiveUpdate: false,
  disableLivestreamTimeRestriction: false,
  videoEnhancedFeatures: false,
  enableDriverAssociationPast: false,
  showObstructionDashboard: false,
  showMatchReview: false,
  showCoblicamUpgradeBanner: false,
  multiCamVideoRequests: false,
  cobliCamProRecordOff: true,
  livestreamConfig: {
    liveTimeout: 60,
    bannerTimeout: 30,
    bannerThreshold: 5,
  },

  // IoT
  enableImmobilizer: false,

  // Data Platform
  integrationsPage: false,

  // Site Visibility
  siteVisibilityTypeform: false,

  // Tools
  ddRumSampleRate: 100,
  ddRumReplaySampleRate: 0,
  useDdRum: false,
  oneSignal: false,
  fuelTypeform: false,

  // Temporary
  showWarningBanner: false,

  // Home Banner
  showScheduleInstallDeviceBanner: false,
  homeBannerCameraBlackFriday: false,

  // Allow list configuration
  enableVehicleDriverAllowList: false,

  // Road Speed Page
  roadSpeedPage: true,

  // Expenses page
  expensesImportButton: true,

  // Costs page
  costsPage: false,

  // Página de multas
  finesPage: false,

  // Info Banners
  safetyInfoBannerDashboard: true,
  cameraEventsInfoBannerIot: true,

  // Coaching Feedback v2 features
  coachingFeedbackV2: false,

  // AI Video Recommendations
  aiChat: false,
  aiVideosRecommendations: false,

  // New Severity Estimator
  videoEventSeverity: false,

  // Blip Chat
  blipChat: false,

  // Safety Ranking
  safetyRankingDash: false,

  // Groups Page
  vehicleGroupsPageVersion: '1',

  // Tracking To Geofence
  routeToGeofence: false,

  // Maintenance and Transaction
  canUseNonAssociatedVehiclesToRegisterMaintenanceAndTransaction: false,

  // App Announcement
  announcementCard: false,

  // Incidents
  sidebarIncidents: false,

  // App Impersonate
  impersonate: false,

  // Maintenance
  maintenance: false,

  // Boletos Button
  alertBoletos: false,
};

type FeatureFlags = typeof featureFlags;

export { featureFlags };
export default FeatureFlags;
